import { useState } from "react";
import { useEscape } from "../hooks/useEscape";

// components
import FormButton from "../formComponents/FormButton";
import InlineInput from "../formComponents/InlineInput";
import { messageAndErrorStore, userStore } from "../store/Store";
import { useNavigate } from "react-router-dom";

export default function AddCompanyPopup({
  setTrigger,
  companyTypeId,
  companyName,
  pcCarrierId,
  pcDriverId,
  company,
  setCompany,
}) {
  // global
  const currentUser = userStore((data) => data.currentUser);
  const JwtToken = userStore((data) => data.JwtToken);
  const setAuthStatus = userStore(data => data.setAuthStatus)
  const toggleNewMessage = messageAndErrorStore(data => data.toggleNewMessage)

  // local
  const [pending, setPending] = useState(false);
  const newCompany = {
    id: 0,
    company_name: companyName,
    company_type_id: companyTypeId,
    pc_carrier_id: pcCarrierId,
    pc_driver_id: pcDriverId,
    created_by_id: currentUser.id,
    updated_by_id: currentUser.id,
  };

  const [newCompanyUser, setNewCompanyUser] = useState({
    id: 0,
    email: "",
    role_id: 4,
    first_name: "",
    last_name: "",
    company_id: 0,
    created_by_id: currentUser.id,
    updated_by_id: currentUser.id,
  });
  const navigate = useNavigate()

  useEscape(setTrigger);

  const handleChange = (e) => {
    setNewCompanyUser({
      ...newCompanyUser,
      [e.target.name]: e.target.value,
    });
  };

  const handleSubmit = (e) => {
    e.preventDefault();
    setPending(true)
    const headers = new Headers()
    headers.append("Content-Type", "application/json")
    headers.append("Authorization", "Bearer " + JwtToken)
    const reqBody = {
      company: newCompany,
      admin_user: newCompanyUser
    }
    const requestOptions = {
      method: "POST",
      headers,
      body: JSON.stringify(reqBody)
    }
    const pattern = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
    const isValid = pattern.test(newCompanyUser.email)
    if (!isValid) {
      setPending(false)
      toggleNewMessage("Not a valid email")
      return
    }
    

    fetch(`${process.env.REACT_APP_BACKEND}/pc/company`, requestOptions)
    .then(res => {
      if (!res.ok) {
        if (res.status === 401) {
          setAuthStatus(false)
          setTrigger(true)
          navigate('/login')
        } else if (res.status === 403) {
          toggleNewMessage("Forbidden")
          setPending(false)
          return Promise.resolve()
        } else if (res.status === 409) {
          toggleNewMessage("Email already exists")
          setPending(false)
          return Promise.resolve()
        } else {
          toggleNewMessage(`Something Went Wrong Status ${res.status}`)
          setPending(false)
          return Promise.resolve()
        }
      } else {
        return res.json()
      }
    })
    .then(data => {
      if (!data) {
        return
      } else {
        if (setCompany && company) {
          setCompany({
            ...company,
            company_id: data
          })
        }
        setPending(false)
        setTrigger(true)
      }
    })
    .catch(err => {
      console.log(err)
      toggleNewMessage("Something Went Wrong")
      setPending(false)
    })
  };

  return (
    <div className="popup">
      <div className="popup-inner">
        <h3>{`Add ${companyName} User`}</h3>
        <InlineInput
          type={"email"}
          name={"email"}
          title={"Email"}
          placeholder={"Primary User Email Address"}
          onChange={handleChange}
          value={newCompanyUser.email}
          required={true}
        />
        <InlineInput
          type={"text"}
          name={"first_name"}
          title={"First Name"}
          placeholder={"Primary User First Name"}
          onChange={handleChange}
          value={newCompanyUser.first_name}
          required={true}
        />
        <InlineInput
          type={"text"}
          name={"last_name"}
          title={"Last Name"}
          placeholder={"Primary User Last Name"}
          onChange={handleChange}
          value={newCompanyUser.last_name}
          required={true}
        />
        <FormButton name={"Submit"} pending={pending} onClick={handleSubmit} />
      </div>
    </div>
  );
}
